import { Dropdown, Popover, Space, Tooltip } from "antd";
import { useContext, useState } from "react";

import { ExportToExcel } from "../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import Something from "../../components/shared/Something";
import Moment from "react-moment";
import UpdateRequester from "./components/UpdateRequester";
import {
  handleExportAutoRequests,
  handleFetchMonthlyRequests,
} from "../../api/autorequests";
import { Link } from "react-router-dom";
import DeleteRequest from "./components/DeleteRequest";
import CompleteRequest from "./components/CompleteRequest";
import { AuthContext } from "../../contexts/AuthContext";
import { ReloadOutlined } from "@ant-design/icons";
import UpdateApprover from "./components/UpdateApprover";
import { Check, ChevronDown, Download } from "lucide-react";
import MoveToExecutor from "./components/MoveToExecutor";
import UpdateExecutor from "./components/UpdateExecutor";
import MainChart from "./components/MainChart";
import moment from "moment";
import UnitRequests from "./components/UnitRequests";
import RoleRequests from "./components/RoleRequests";
import MontlyWrapper from "./components/MontlyWrapper";

export default function AutoDashboard({ status }: any) {
  const { user } = useContext(AuthContext);
  const [requesterModal, setRequesterModal] = useState<boolean>(false);
  const [approverModal, setApproverModal] = useState<boolean>(false);
  const [executorModal, setExecutorModal] = useState<boolean>(false);
  const [moveToExecutorModal, setMoveToExecutorModal] =
    useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [completeModal, setCompleteModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  const year = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(year);
  const [dateRange, setDateRange] = useState<any>({
    startDate: moment().startOf("year").format("YYYY-MM-DD"),
    endDate: moment().endOf("year").format("YYYY-MM-DD"),
  });
  const month = moment().month() + 1;

  const {
    data: monthlyRequests,
    isFetching,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["monthlyRequests", dateRange.startDate, dateRange.endDate],
    queryFn: () =>
      handleFetchMonthlyRequests({
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      }),
  });

  const items: any[] = [year, year - 1, year - 2, year - 3];

  const years = (
    <div>
      {items?.map((item: any, index: number) => (
        <div
          className="flex flex-col justify-start items-start w-full text-3xs"
          key={index}
        >
          <button
            onClick={() => {
              setSelectedYear(item);
              setDateRange({
                startDate: `${item}-01-01`,
                endDate: `${item}-12-31`,
              });
            }}
            className="py-1 border-t focus:outline-none w-full flex items-start"
          >
            <div
              className={`${
                selectedYear === item ? "bg-green-600" : ""
              } w-6 h-6 border mr-2 flex items-center justify-center text-white`}
            >
              <Check />
            </div>
            <div className="flex  flex-1 text-black">{item}</div>
          </button>
        </div>
      ))}
    </div>
  );

  const exportRequests = async () => {
    setExporting(true);
    const res = await handleExportAutoRequests();
    await ExportToExcel(
      res.records?.map((item: any, index: number) => {
        return {
          "S/N": index + 1,
          "Requested For": item?.name || "-",
          User: item?.isNewUser ? "New" : "Existing",
          Email: item?.email || "-",
          Mobile: item?.mobile || "-",
          "For Role": item?.designation || "-",
          Companies: item?.companies?.map((company: any) => company).join(", "),
          Levels: item?.levels?.map((level: any) => level).join(", "),
          "Requested By": item?.requestedBy?.name || "-",
          "Requested At": (
            <Moment format="DD/MM/YYYY">{item?.createdAt}</Moment>
          ),
          "Approved By": item?.approvedBy?.name || "-",
          "Approved At": (
            <Moment format="DD/MM/YYYY">{item?.dateApproved}</Moment>
          ),
          "Executed By": item?.executedBy?.name || "-",
          "Executed At": (
            <Moment format="DD/MM/YYYY">{item?.dateExecuted}</Moment>
          ),
          Status: item?.status || "-",
          Completed: item?.isCompleted ? "Yes" : "No",
        };
      }),
      "AutolineRequests.xlsx"
    );
    setExporting(false);
  };

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border p-2">
          <div className="">
            <div className="font-bold capitalize text-lg">
              Autoline Access Requests
            </div>
            <div className="text-gray-600">Manage all request approvals</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100 shadow-sm"
                onClick={() => exportRequests()}
              >
                {isExporting ? <ReloadOutlined /> : <Download size={12} />}
                <span className="mx-1">Export</span>
              </button>
            </Tooltip>
            {access?.includes(user?.accessLevel) && (
              <Link
                to={"/autoline/requests/new"}
                className="flex mx-2 justify-center items-center border px-4 h-8  bg-karimjee  hover:bg-karimjee-dark text-white shadow-sm"
              >
                + New
              </Link>
            )}

            <Popover content={years} title="Years" placement="bottom">
              <button className="flex items-center cursor-pointer focus:outline-none text-3xs border px-2 gap-x-2 h-8">
                <div className="">{selectedYear}</div>
                <div className="">
                  <ChevronDown />
                </div>
              </button>
            </Popover>
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2">
            <UnitRequests dateRange={dateRange} />
            <div className="grid grid-cols-12 gap-x-2">
              <div className="col-span-12 sm:col-span-2">
                <MontlyWrapper
                  month={month}
                  monthlyRequests={monthlyRequests}
                />
              </div>
              <div
                className="col-span-12 sm:col-span-6"
                style={{ height: 600, width: "100%" }}
              >
                <MainChart data={monthlyRequests?.data} dateRange={dateRange} />
              </div>
              <div className="col-span-12 sm:col-span-4">
                <RoleRequests dateRange={dateRange} />
              </div>
            </div>
          </div>
        )}
      </div>
      {requesterModal && (
        <UpdateRequester
          isVisible={requesterModal}
          setVisible={setRequesterModal}
          selected={selected || {}}
        />
      )}

      {approverModal && (
        <UpdateApprover
          isVisible={approverModal}
          setVisible={setApproverModal}
          selected={selected || {}}
        />
      )}
      {moveToExecutorModal && (
        <MoveToExecutor
          isVisible={moveToExecutorModal}
          setVisible={setMoveToExecutorModal}
          selected={selected || {}}
        />
      )}
      {executorModal && (
        <UpdateExecutor
          isVisible={executorModal}
          setVisible={setExecutorModal}
          selected={selected || {}}
        />
      )}
      {deleteModal && (
        <DeleteRequest
          isVisible={deleteModal}
          setVisible={setDeleteModal}
          selected={selected || {}}
        />
      )}
      {completeModal && (
        <CompleteRequest
          isVisible={completeModal}
          setVisible={setCompleteModal}
          selected={selected || {}}
        />
      )}
    </div>
  );
}
